// Textos del módulo Dashboard (panel ejecutivo + vista cocina). Ver src/i18n/textos.ts.
import { defineTextos } from '../textos.ts';

export const textosDashboard = defineTextos({
  // --- Vista cocina (KitchenDashboard) ---
  errorDesconocido: 'error desconocido',
  ahora: 'ahora',
  errorPedidos: 'No se pudieron cargar los pedidos: {error}. Esta pantalla puede estar mostrando menos pedidos de los que hay.',
  pedidosEnVivo: 'Pedidos en vivo',
  enVivo: 'EN VIVO',
  recargar: 'Recargar',
  salir: 'Salir',
  pantallaCompleta: 'Pantalla completa',
  colEnPreparacion: 'En preparación',
  colListos: 'Listos para entregar',
  colEntregados: 'Entregados (últimos 10 min)',
  sinPedidosCocina: 'Sin pedidos en cocina',
  sinPedidosListos: 'Sin pedidos listos',
  sinEntregasRecientes: 'Sin entregas recientes',
  hace: 'hace {tiempo}',
  mesaN: 'Mesa {nombre}',
  grupoN: 'Grupo {nombre}',
  paraLlevar: 'Para llevar',
  // --- Panel ejecutivo ---
  errorInventario: 'No se pudo cargar el inventario: las alertas de stock de esta pantalla no son confiables.',
  errorDatos: 'No se pudieron cargar los datos del dashboard',
  volverAlPanel: '← Volver al panel',
  vistaCocina: 'Vista cocina',
  buenDia: 'Buen día',
  ventasHoy: 'Ventas hoy',
  ticketProm: 'Ticket prom.',
  pedidosActivos: 'Pedidos activos',
  mesasOcupadas: 'Mesas ocupadas',
  inventarioCritico: '⚠ Inventario crítico',
  inventarioBajoMinimo: 'Inventario bajo mínimo',
  agotadoN: '{n} agotado · ',
  agotadosN: '{n} agotados · ',
  criticoN: '{n} crítico · ',
  criticosN: '{n} críticos · ',
  bajoMinimoN: '{n} bajo mínimo · ',
  clickGestionar: 'Click para gestionar →',
  factura: 'factura',
  facturas: 'facturas',
  ticketPromedio: 'Ticket promedio',
  porCuentaCerrada: 'por cuenta cerrada',
  sinVentasHoy: 'sin ventas hoy',
  sinPedidosActivos: 'sin pedidos activos',
  pctOcupacion: '{pct}% de ocupación',
  sinMesasCargadas: 'sin mesas cargadas',
  ventasPorHora: 'Ventas por hora — hoy',
  facturasRegistradasHoy: '{n} facturas registradas hoy',
  sinFacturasHoy: 'Sin facturas hoy todavía',
  faltanVentas: 'Faltan datos: no hay ventas registradas hoy todavía.',
  ventas: 'Ventas',
  top5: 'Top 5 productos',
  porUnidadesHoy: 'por unidades vendidas hoy',
  sinDatos: 'sin datos',
  faltanProductos: 'Faltan datos: ningún producto se ha vendido hoy todavía.',
  nUnidades: '{n} unidades',
  cantidad: 'Cantidad',
  pedidosPorEstado: 'Pedidos por estado',
  pasoDelFlujo: 'cuántos hay en cada paso del flujo',
  sinPedidosActivosAhora: 'Sin pedidos activos en este momento.',
  estadoAbierto: 'Abierto',
  estadoEnPreparacion: 'En preparación',
  estadoListo: 'Listo',
  estadoEntregado: 'Entregado',
  estadoPrefactura: 'Prefactura',
  // Estado crudo (el valor del backend) en el resumen "2 abierto · 1 listo".
  // En español se muestra el valor tal cual, igual que antes.
  crudoAbierto: 'abierto',
  crudoEnPreparacion: 'en_preparacion',
  crudoListo: 'listo',
  crudoEntregado: 'entregado',
  crudoFacturado: 'facturado',
  ocupacionMesas: 'Ocupación de mesas',
  mesasOcupadasDe: '{o} de {t} mesas ocupadas',
  sinMesasRegistradas: 'sin mesas registradas',
  noHayMesasSede: 'No hay mesas registradas en esta sede.',
  ocupadas: 'ocupadas',
  libres: 'Libres',
  conPedido: 'Con pedido',
  porCobrar: 'Por cobrar',
  reservadas: 'Reservadas',
}, {
  errorDesconocido: 'unknown error',
  ahora: 'now',
  errorPedidos: 'Could not load the orders: {error}. This screen may be showing fewer orders than there are.',
  pedidosEnVivo: 'Live orders',
  enVivo: 'LIVE',
  recargar: 'Reload',
  salir: 'Exit',
  pantallaCompleta: 'Full screen',
  colEnPreparacion: 'In preparation',
  colListos: 'Ready to deliver',
  colEntregados: 'Delivered (last 10 min)',
  sinPedidosCocina: 'No orders in the kitchen',
  sinPedidosListos: 'No orders ready',
  sinEntregasRecientes: 'No recent deliveries',
  hace: '{tiempo} ago',
  mesaN: 'Table {nombre}',
  grupoN: 'Group {nombre}',
  paraLlevar: 'Takeout',
  errorInventario: 'Could not load the inventory: the stock alerts on this screen are not reliable.',
  errorDatos: 'Could not load the dashboard data',
  volverAlPanel: '← Back to dashboard',
  vistaCocina: 'Kitchen view',
  buenDia: 'Hello',
  ventasHoy: 'Sales today',
  ticketProm: 'Avg. ticket',
  pedidosActivos: 'Active orders',
  mesasOcupadas: 'Occupied tables',
  inventarioCritico: '⚠ Critical inventory',
  inventarioBajoMinimo: 'Inventory below minimum',
  agotadoN: '{n} out of stock · ',
  agotadosN: '{n} out of stock · ',
  criticoN: '{n} critical · ',
  criticosN: '{n} critical · ',
  bajoMinimoN: '{n} below minimum · ',
  clickGestionar: 'Click to manage →',
  factura: 'invoice',
  facturas: 'invoices',
  ticketPromedio: 'Average ticket',
  porCuentaCerrada: 'per closed bill',
  sinVentasHoy: 'no sales today',
  sinPedidosActivos: 'no active orders',
  pctOcupacion: '{pct}% occupancy',
  sinMesasCargadas: 'no tables loaded',
  ventasPorHora: 'Sales by hour (today)',
  facturasRegistradasHoy: '{n} invoices recorded today',
  sinFacturasHoy: 'No invoices today yet',
  faltanVentas: 'Missing data: no sales recorded today yet.',
  ventas: 'Sales',
  top5: 'Top 5 products',
  porUnidadesHoy: 'by units sold today',
  sinDatos: 'no data',
  faltanProductos: 'Missing data: no product has been sold today yet.',
  nUnidades: '{n} units',
  cantidad: 'Quantity',
  pedidosPorEstado: 'Orders by status',
  pasoDelFlujo: 'how many are at each step of the flow',
  sinPedidosActivosAhora: 'No active orders right now.',
  estadoAbierto: 'Open',
  estadoEnPreparacion: 'In preparation',
  estadoListo: 'Ready',
  estadoEntregado: 'Delivered',
  estadoPrefactura: 'Pre-invoice',
  crudoAbierto: 'open',
  crudoEnPreparacion: 'in preparation',
  crudoListo: 'ready',
  crudoEntregado: 'delivered',
  crudoFacturado: 'pre-invoiced',
  ocupacionMesas: 'Table occupancy',
  mesasOcupadasDe: '{o} of {t} tables occupied',
  sinMesasRegistradas: 'no tables registered',
  noHayMesasSede: 'There are no tables registered at this branch.',
  ocupadas: 'occupied',
  libres: 'Free',
  conPedido: 'With order',
  porCobrar: 'To charge',
  reservadas: 'Reserved',
});

export type ClaveDashboard = keyof typeof textosDashboard.es;
